import * as React from "react";
import { Col, Row, Button } from "reactstrap";
import {
  formatCapitalized,
  momentToString,
  momentAgeNow
} from "../../../../share/utils/utils";
import { IIndexedCase } from "src/share/types/case/searchCase";

export interface ICaseCardProps {
  caseInfo: IIndexedCase;
  onCaseRedirect: (childId: string, caseId: string) => void;
  onScrollPosition: (childId: string, caseId: string) => void;
}

const CaseCard: React.FC<ICaseCardProps> = ({
  caseInfo,
  onCaseRedirect,
  onScrollPosition
}) => {
  React.useEffect(() => {
    onScrollPosition(caseInfo.childId, caseInfo.caseId);
  }, []);

  return (
    <Col
      xl="4"
      lg="6"
      md="12"
      sm="12"
      xs="12"
      className="card-column"
      id={caseInfo.childId + caseInfo.caseId}
    >
      <div className="info-card white-background">
        <Row>
          <Col md="3" sm="3" xs="3">
            <div className="logo-background">
              <img src={caseInfo.portrait} alt="Logo" />
            </div>
          </Col>
          <Col md="9" sm="9" xs="9" className="card-head">
            <div className="case-child-name">
              {formatCapitalized(caseInfo.fullName)}
            </div>
            <div className="case-data">
              <p>
                <label>Missing date:</label>
                {momentToString(caseInfo.missingSince)}
              </p>
              <p>
                <label>Birthdate:</label>
                {(caseInfo.birthDate as any).isValid()
                  ? `${momentToString(caseInfo.birthDate)} (${momentAgeNow(
                      caseInfo.birthDate
                    )}  years)`
                  : "Unknown"}
              </p>
            </div>
          </Col>
        </Row>
        <hr className="card-separator" />
        <Row className="top-space">
          <Col md="6" className="subFont">
            <div className="case-data">
              <p>
                <label>Country:</label>
                {formatCapitalized(caseInfo.country)}
              </p>
              <p>
                <label>State:</label>
                {caseInfo.state ? formatCapitalized(caseInfo.state) : "Unknown"}
              </p>
              <p>
                <label>City:</label>
                {caseInfo.city ? formatCapitalized(caseInfo.city) : "Unknown"}
              </p>
            </div>
          </Col>
          <Col md="6" className="subFont">
            <div className="case-data">
              <p>
                <label>Type:</label>
                {formatCapitalized(caseInfo.type)}
              </p>
              <p>
                <label>Agency:</label>
                {caseInfo.agencyCode}
              </p>
              <p>
                <label>Status:</label>
                {formatCapitalized(caseInfo.status)}
              </p>
            </div>
          </Col>
          <Col md="12" className="card-view-button">
            <Button
              className="btn-blue btn-view"
              onClick={() => onCaseRedirect(caseInfo.childId, caseInfo.caseId)}
            >
              View
            </Button>
          </Col>
        </Row>
      </div>
    </Col>
  );
};

export default React.memo(CaseCard);
